<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-ministry-sidebar></app-ministry-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div class="card shadow m-3" style="width: 100%">
              <div
                class="
                  card-header
                  heading_n_button_box
                  card-header-cus-new-appoint
                "
              >
                <div class="card-heading">
                  <h4>List of Passengers with Forged Results</h4>
                </div>

                <div class="button-section mt-1"></div>
              </div>

              <div class="card-body">
                <div class="col-lg-12">
                  <div class="col-lg-12">
                    <form
                      [formGroup]="searchForm"
                      (ngSubmit)="onSubmitSearch(searchForm.value)"
                    >
                      <div class="form-row">
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="passengerName"
                            placeholder="Passenger Name"
                            formControlName="passengerName"
                            id="passengerName"
                            autocomplete="off"
                          />
                        </div>
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="passportNumber"
                            placeholder="Passport Number"
                            formControlName="passportNumber"
                            id="passportNumber"
                            autocomplete="off"
                          />
                        </div>
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="phone"
                            placeholder="Phone Number"
                            formControlName="phone"
                            id="phone"
                            autocomplete="off"
                          />
                        </div>

                        <div class="col">
                          <div class="mr-4">
                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                              "
                              type="submit"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fas fa-search"></i> Search
                            </button>

                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                                ml-2
                              "
                              type="button"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                              (click)="clearSearch()"
                            >
                              <i class="fas fa-sync-alt"></i> Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="">
                    <div class="table-responsive mt-3">
                      <div class="col-auto">
                        <div class="row" *ngIf="forgedresults">
                          <div class="show-record mt-3 mbm-32">
                            <span>Show</span> &nbsp;
                            <select
                              class="
                                custom-select custom-select-sm
                                form-control form-control-sm
                              "
                              (change)="setItemsPerPage(page.value)"
                              #page
                            >
                              <option [selected]="currentPageLength == 10">
                                10
                              </option>
                              <option [selected]="currentPageLength == 30">
                                30
                              </option>
                              <option [selected]="currentPageLength == 50">
                                50
                              </option>
                              <option [selected]="currentPageLength == 100">
                                100
                              </option>
                              <option [selected]="currentPageLength == 500">
                                500
                              </option>
                              <option [selected]="currentPageLength == 1000">
                                1000
                              </option>
                            </select>
                            &nbsp;
                            <span> entries</span>
                          </div>
                        </div>
                      </div>

                      <table
                        *ngIf="forgedresults"
                        class="
                          table
                          table-bordered
                          table-condensed
                          table-responsive-sm
                          table-responsive-md
                          table-responsive-lg
                          table-responsive-xl
                          nowrap
                        "
                        datatable
                        [dtOptions]="dtOptions"
                        width="100%"
                      >
                        <thead class="">
                          <tr>
                            <th scope="col">S/N</th>
                            <th scope="col">Passenger ID</th>
                            <th scope="col">Passenger Name</th>
                            <th scope="col">Passport Number</th>
                            <th scope="col">Phone Number</th>
                            <th scope="col">Email</th>
                            <th scope="col">Gender</th>
                            <th scope="col">Status</th>
                            <th scope="col">Country Of Residence</th>
                            <th scope="col">Nationality</th>
                            <th scope="col">Date Of Birth</th>

                            <!-- <th scope="col">Date Of Departure</th>
                            <th scope="col">Scheduled Date For COVID Test</th> -->
                            <!-- <th scope="col">Address</th> -->
                            <!-- <th scope="col">Airline</th>                            -->
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody class="dashboard-bg-white">
                          <tr
                            *ngFor="
                              let result of forgedresults | paginate: config;
                              index as i
                            "
                          >
                            <th scope="row">
                              {{
                                config.itemsPerPage * (config.currentPage - 1) +
                                  i +
                                  1
                              }}
                            </th>
                            <td>{{ result.ctms_passenger_id }}</td>
                            <td>
                              {{ result.first_name }}
                              {{ result.middle_name }}
                              {{ result.last_name }}
                            </td>
                            <td>{{ result.passport_no }}</td>
                            <td>{{ result.phone }}</td>
                            <td>{{ result.email }}</td>
                            <td>{{ result.gender }}</td>
                            <td>
                              <span class="text-danger">
                                {{ result.status }}
                              </span>
                            </td>
                            <td>{{ result.country_residence }}</td>
                            <td>{{ result.nationality }}</td>
                            <td>{{ result.dob }}</td>
                            <!-- <td>{{ result.created_at | date: "medium" }}</td> -->
                            <th>
                              <button
                                class="btn-view"
                                type="button"
                                (click)="showDetails(result, showDetailsModal)"
                                title="View Details"
                              >
                                <i class="far fa-eye"></i>
                              </button>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      <div class="table-footer">
                        <div
                          id="page_info"
                          class="mt-3 record-show-text-bottom"
                          *ngIf="forgedresults"
                        >
                          Showing
                          {{
                            (config.currentPage - 1) * config.itemsPerPage + 1
                          }}
                          - {{ config.currentPage * config.itemsPerPage }} of
                          {{ config.totalItems }} entries
                        </div>

                        <div
                          class="pagination paging-pull-right"
                          *ngIf="forgedresults"
                        >
                          <pagination-controls
                            (pageChange)="pageChange($event)"
                            class="my-pagination mt-2 pagination-server"
                          >
                          </pagination-controls>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Result Template -->
<ng-template #showDetailsModal let-modal>
  <div class="card col-lg-12">
    <div class="row">
      <div class="card-header col-lg-12 header-dashboard-button-2">
        <h3>
          {{ passengerSingleResponse.passenger_info?.first_name }}
          {{ passengerSingleResponse.passenger_info?.middle_name }}
          {{ passengerSingleResponse.passenger_info?.last_name }} Details
        </h3>
        <button class="close-button" (click)="modal.close('Save click')">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="card-body p-4">
        <div class="container">
          <div class="row justify-content-center bg-light">
            <!-- <div class="col-md-2">
              <img
                src="https://via.placeholder.com/100"
                width="100"
                height="100"
                alt="Logo"
                class="border rounded-0"
              />
            </div> -->
            <div class="col-md-12 text-center">
              <h4 class="text-dark font-weight-bold">
                {{ passengerSingleResponse.covidtest_info?.lab_name }}
              </h4>
              <!-- <h5 class="text-dark font-weight-normal">
                A MEMBER OF THE EG COVID-19 LABORATORY CONSORTIUM EQUITORIAL
                GUINEA
              </h5> -->
              <!-- <h4 class="text-dark font-weight-bold">
                VIRILOGY PCR TEST REPORT FOR COVID-19
              </h4> -->
            </div>
            <!-- <div class="col-md-2">
                <img
                  src="https://via.placeholder.com/100"
                  width="100"
                  height="100"
                  alt="QR_Code"
                  class="border rounded-0"
                />
                <p class="font-weight-bold">No 63028175</p>
              </div> -->

            <!-- <div class="col-md-12">
                  <span class="ml-5">To verify the authenticity of this test result, visit
                    <a
                      href="https://covid19.medfit.com.ng/verify-result">https://covid19.medfit.com.ng/verify-result</a></span>
                </div> -->
          </div>

          <!-- <div class="row justify-content-center mt-5">
              <div class="col-md-12 text-center">
                <h4 class="font-weight-bold">
                  <u>VIROLOGICAL SCREENING TEST FOR COVID-19 OUTBREAK</u>
                </h4>
              </div>
            </div> -->

          <div class="row mt-4 ml-1">
            <span
              ><strong>Date: </strong
              ><u>
                {{
                  passengerSingleResponse.covidtest_info?.test_date
                    | date: "medium"
                }}
              </u></span
            >

            <!-- <span class="ml-5"
                >
                <strong>Appointment ID: </strong><u> 484848484 </u>
                </span
              > -->
          </div>

          <div class="container mt-3 bg-white">
            <div class="row">
              <div class="col-md-7 border border-secondary">
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">NAME: </span>
                    {{ passengerSingleResponse.passenger_info?.first_name }}
                    {{ passengerSingleResponse.passenger_info?.middle_name }}
                    {{
                      passengerSingleResponse.passenger_info?.last_name
                    }}</span
                  >
                </p>

                <!-- <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">SAMPLE COLLECTED ON: </span>
                    23/07/2021</span
                  >
                  <span class="ml-5">
                    <img
                      src="{{https://via.placeholder.com/100}}"
                      width="100"
                      height="100"
                      alt="Logo"
                      class="border rounded-0"
                    />
                  </span>
                </p> -->
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">AGE: </span>
                    {{ passengerSingleResponse.passenger_info?.dob | age }}
                  </span>
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">SEX: </span>
                    {{ passengerSingleResponse.passenger_info?.gender }}
                  </span>
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">ADDRESS: </span>
                    {{
                      passengerSingleResponse.passenger_info
                        ?.address_residential
                    }}</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">PHONE NO: </span>
                    {{ passengerSingleResponse.passenger_info?.phone }}</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">EMAIL: </span>
                    {{ passengerSingleResponse.passenger_info?.email }}</span
                  >
                </p>
                <p class="text-dark">
                  <span
                    ><span class="font-weight-bold">NATIONALITY: </span>
                    {{
                      passengerSingleResponse.passenger_info?.nationality
                    }}</span
                  >
                </p>
                <!-- <p class="text-dark">
                    <span
                      ><span class="font-weight-bold">PASSPORT NO.: </span>
                      DO0867543</span
                    >
                  </p> -->

                <!-- <p class="text-dark">
                    <span
                      ><span class="font-weight-bold"
                        >COUNTRY OF RESIDENCE:
                      </span>
                      Nigeria</span 
                    >
                  </p> -->
              </div>

              <!-- <div class="col-md-2">
                  <p class="text-dark">
                    <span
                      ><span class="font-weight-bold">SAMPLE COLLECTED: </span>
                      <br />
                      20/07/2021
                    </span>
                  </p>
                  <p class="text-dark">
                    <span
                      ><span class="font-weight-bold">COLLECTED VIA: </span>
                      <br />
                      Nose
                    </span>
                  </p>
               
                </div> -->

              <div class="col-md-5 border border-secondary">
                <!-- <p class="text-dark">
                  <span
                    ><span class="font-weight-bold"
                      >SAMPLE(S): <br />
                      SCREENING
                    </span>
                  </span>
                </p> -->

                <!-- <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">NASOPHARYNGEAL</th>
                      <th scope="row">xxxxxxxxxxx</th>
                    </tr>
                    <tr>
                      <th scope="row">OROPHARYNGEAL</th>
                      <th scope="row">xxxxxxxxxxx</th>
                    </tr>
                    <tr>
                      <th scope="row">SPUTUM</th>
                      <th scope="row"></th>
                    </tr>
                    <tr>
                      <th scope="row">BLOOD</th>
                      <th scope="row"></th>
                    </tr>
                    <tr>
                      <th scope="row">OTHERS</th>
                      <th scope="row"></th>
                    </tr>
                  </tbody>
                </table> -->

                <p class="mt-4 mb-3 text-dark">
                  <span class="font-weight-bold">DATE OF RESULT: </span>
                  {{
                    passengerSingleResponse.covid_labresult_info?.result_date
                  }}

                  <!-- <span class="font-weight-bold ml-3">VALIDITY: </span>
                    27/07/2021 -->
                </p>

                <table class="table table-light">
                  <tbody>
                    <tr>
                      <th scope="row">
                        RESULT:
                        <span
                          class="text-danger ml-3"
                          *ngIf="
                            passengerSingleResponse.covid_labresult_info
                              ?.status == 'POSITIVE'
                          "
                        >
                          POSITIVE
                        </span>
                        <span
                          class="text-success ml-3"
                          *ngIf="
                            passengerSingleResponse.covid_labresult_info
                              ?.status != 'POSITIVE'
                          "
                        >
                          NEGATIVE
                        </span>
                      </th>
                      <!-- <th scope="row">
                       
                      </th> -->
                    </tr>

                    <!-- <tr>
                      <th scope="row">POSITIVE</th>
                      <th scope="row">X</th>
                    </tr>
                    <tr>
                      <th scope="row">NEGATIVE</th>
                      <th scope="row">-</th>
                    </tr>
                    <tr>
                      <th scope="row">INCONCLUSIVE</th>
                      <th scope="row"></th>
                    </tr> -->
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Result -->
          <div
            class="row mt-5 ml-1"
            *ngIf="passengerSingleResponse.covidtest_info"
          >
            <span><span class="font-weight-bold">RESULT: </span></span>
          </div>

          <div class="container" *ngIf="passengerSingleResponse.covidtest_info">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">LAB NAME</th>
                  <th scope="col">LAB PHONE</th>
                  <th scope="col">LAB EMAIL</th>
                  <th scope="col">COUNTRY</th>
                  <th scope="col">TEST DATE</th>
                  <th scope="col">TEST RESULT</th>
                  <th scope="col">VIEW TEST</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ passengerSingleResponse.covidtest_info.lab_name }}</td>
                  <td>
                    {{ passengerSingleResponse.covidtest_info.lab_phone }}
                  </td>
                  <td>
                    {{ passengerSingleResponse.covidtest_info.lab_email }}
                  </td>
                  <td>{{ passengerSingleResponse.covidtest_info.country }}</td>
                  <td>
                    {{ passengerSingleResponse.covidtest_info.test_date }}
                  </td>
                  <td>
                    {{ passengerSingleResponse.covidtest_info.test_result }}
                  </td>
                  <td>
                    <a
                      [href]="passengerSingleResponse.covidtest_info.report_url"
                      >View Result</a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End Result -->

          <!-- Travel Info -->
          <div
            class="row mt-5 ml-1"
            *ngIf="passengerSingleResponse.travel_info"
          >
            <span><span class="font-weight-bold">TRAVEL INFORMATION: </span></span>
          </div>

          <div class="container" *ngIf="passengerSingleResponse.travel_info">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">TYPE</th>
                  <th scope="col">DEPARTING COUNTRY</th>
                  <th scope="col">DEPARTURE DATE</th>
                  <th scope="col">RETURN DATE</th>
                  <th scope="col">ARRIVING COUNTRY</th>
                  <th scope="col">ARRIVAL STATE</th>
                  <th scope="col">ARRIVAL DATE</th>
                  <th scope="col">TRANSIT COUNTRY</th>
                  <th scope="col">AIRLINE</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{
                      passengerSingleResponse.travel_info.type == "1"
                        ? "Outbound"
                        : "Inbound"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.travel_info.departure_country
                        ? passengerSingleResponse.travel_info.departure_country
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.travel_info.departure_date
                        ? passengerSingleResponse.travel_info.departure_date
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.travel_info.return_date
                        ? passengerSingleResponse.travel_info.return_date
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.travel_info.arrival_country
                        ? passengerSingleResponse.travel_info.arrival_country
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.travel_info.arrival_state
                        ? passengerSingleResponse.travel_info.arrival_state
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.travel_info.arrival_date
                        ? passengerSingleResponse.travel_info.arrival_date
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.travel_info.arrival_country
                        ? passengerSingleResponse.travel_info.arrival_country
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.travel_info.airline
                        ? passengerSingleResponse.travel_info.airline
                        : "N/A"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End Travel Info -->

          <!-- Booking Info -->
          <div
            class="row mt-5 ml-1"
            *ngIf="passengerSingleResponse.booking_info"
          >
            <span><span class="font-weight-bold">BOOKING INFORMATION: </span></span>
          </div>

          <div class="container" *ngIf="passengerSingleResponse.booking_info">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">PREFERED STATE</th>
                  <th scope="col">EXPECTED STATE</th>
                  <th scope="col">EXPECTED CITY</th>
                  <th scope="col">BOOKING DATE</th>
                  <th scope="col">BOOKING TIME</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{
                      passengerSingleResponse.booking_info.prefer_state
                        ? passengerSingleResponse.booking_info.prefer_state
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.booking_info.expected_state
                        ? passengerSingleResponse.booking_info.expected_state
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.booking_info.expected_city
                        ? passengerSingleResponse.booking_info.expected_city
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.booking_info.booking_date
                        ? passengerSingleResponse.booking_info.booking_date
                        : "N/A"
                    }}
                  </td>
                  <td>
                    {{
                      passengerSingleResponse.booking_info.booking_time
                        ? passengerSingleResponse.booking_info.booking_time
                        : "N/A"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End Booking Info -->

          <!-- Comment -->
          <!-- <div class="row mt-5">
            <div class="col-md-12 text-dark">
              <div class="border" style="border-radius: 20%; padding: 2%">
                <p>
                  <span class="font-weight-bold"><u>GENERAL COMMENT</u></span>
                </p>
                <p>
                  <span class="font-weight-bold"
                    >NEGATIVE FOR COV 2 (COVID-19) AS AT:
                  </span>
                  <u>23/07/2021</u>
                </p>
              </div>
            
              <div>
                <p><span class="font-weight-bold">Signature: </span></p>
                    <p>............................</p>

                <p>
                  <span class="font-weight-bold">NAME: </span>
                  DR JOHN DOE
                </p>

                <p>
                  <span class="font-weight-bold">DESIGNATION: </span> HEAD OF
                  LABORATORY DEPARTMENT
                </p>
              </div>
            </div>
          </div> -->
          <!-- Comment  - End -->

          <!-- Contact Info box -->
          <!-- <div class="row mt-5 mb-5">
            <div class="col-md-12 result-footer text-center p-3">
              <div class="">
                <span class="font-weight-bold">Address: </span>
                HEALTH CARE, EQUITORIAL GUINEA
              </div>
              <hr />

              <div class="">
                <span class="font-weight-bold">Phone: </span>08048474838
                <span class="font-weight-bold ml-3">Email: </span>mail@gmail.com
              
              </div>
            </div>
          </div> -->
          <!-- Contact Info box -->
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Passenger Details -->
<ng-template #HIDDENshowDetailsModal let-modal>
  <div class="card mb-5">
    <div class="card-header heading_n_button_box">
      <h3>
        {{ passengerSingleResponse.first_name }}
        {{ passengerSingleResponse.middle_name }}
        {{ passengerSingleResponse.last_name }} Details
      </h3>
      <button
        type="button"
        class="close-button"
        (click)="modal.close('Save click')"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="card-body p-4">
      <div class="row mt-3">
        <div class="col-md-5">
          <p class="text-dark">
            <span>
              <span class="font-weight-bold">PASSENGER ID: </span>
              {{ passengerSingleResponse.ctms_passenger_id }}
            </span>
          </p>
          <p class="text-dark">
            <span>
              <span class="font-weight-bold">PASSENGER NAME: </span>
              {{ passengerSingleResponse.first_name }}
              {{ passengerSingleResponse.middle_name }}
              {{ passengerSingleResponse.last_name }}

              <span class="ml-5 font-weight-bold">GENDER: </span>
              {{ passengerSingleResponse.gender }}
            </span>
          </p>
          <p class="text-dark">
            <span
              ><span class="font-weight-bold">PASSPORT NO.: </span>
              {{ passengerSingleResponse.passport_no }}</span
            >
          </p>
          <p class="text-dark">
            <span
              ><span class="font-weight-bold">EMAIL: </span>
              {{ passengerSingleResponse.email }}</span
            >
          </p>
          <p class="text-dark">
            <span
              ><span class="font-weight-bold">PHONE: </span>
              {{ passengerSingleResponse.phone }}</span
            >
          </p>

          <p class="text-dark">
            <span
              ><span class="font-weight-bold">DATE OF BIRTH: </span>
              {{ passengerSingleResponse.dob }}

              <span class="ml-5 font-weight-bold">AGE: </span>
              {{ passengerSingleResponse.dob | age }}
            </span>
          </p>
          <p class="text-dark">
            <span
              ><span class="font-weight-bold">REGISTERATION DATE: </span>
              {{ passengerSingleResponse.created_at | date: "medium" }}</span
            >
          </p>
          <!-- <p class="text-dark">
            <span
              ><span class="font-weight-bold">LAST LOGIN: </span>
              {{ passengerSingleResponse.last_login | date: "medium" }}</span
            >
          </p> -->
        </div>

        <div class="col-md-5">
          <p class="text-dark">
            <span
              ><span class="font-weight-bold">COUNTRY OF RESIDENCE: </span>
              {{ passengerSingleResponse.country_residence }}</span
            >
          </p>
          <p class="text-dark">
            <span
              ><span class="font-weight-bold">RESIDENTIAL ADDRESS: </span>
              {{ passengerSingleResponse.address_residential }}
            </span>
          </p>
          <p class="text-dark">
            <span
              ><span class="font-weight-bold">NATIONALITY: </span>
              {{ passengerSingleResponse.nationality }}</span
            >
          </p>
          <p class="text-dark">
            <span
              ><span class="font-weight-bold">OCCUPATION: </span>
              {{ passengerSingleResponse.occupation }}
            </span>
          </p>
          <p class="text-dark">
            <span
              ><span class="font-weight-bold">TRAVEL HISTORY COUNT: </span>
              {{ passengerSingleResponse.travel_info?.length }}</span
            >
          </p>
          <p class="text-dark">
            <span
              ><span class="font-weight-bold">STATUS: </span>
              <span class="text-danger">
                {{ passengerSingleResponse.status }}
              </span>
            </span>
          </p>
          <!-- <p class="text-dark">
              <span><span class="font-weight-bold">QR CODE STATUS: </span>
                {{passengerSingleResponse.qrcode_status ? 'TRUE' : 'FALSE'}}
              </span>
            </p> -->
        </div>
      </div>

      <!-- Start Travel History Table  -->
      <div
        class="row"
        *ngIf="
          passengerSingleResponse.travel_info &&
          passengerSingleResponse.travel_info.length
        "
      >
        <hr />
        <div class="col-md-12">
          <div class="">
            <div class="mt-5">
              <div class="col-auto">
                <div class="row">
                  <div class="col-md-12">
                    <h3>Travel Record</h3>
                  </div>
                </div>

                <!-- <div class="row">                    
                  <div class="show-record mt-3 mbm-32">
                    <span>Show</span> &nbsp;
                    <select
                      class="
                        custom-select custom-select-sm
                        form-control form-control-sm
                      "
                      (change)="setItemsPerPage(page.value)"
                      #page
                    >
                      <option [selected]="currentPageLength == 10">
                        10
                      </option>
                      <option [selected]="currentPageLength == 30">
                        30
                      </option>
                      <option [selected]="currentPageLength == 50">
                        50
                      </option>
                      <option [selected]="currentPageLength == 100">
                        100
                      </option>
                      <option [selected]="currentPageLength == 500">
                        500
                      </option>
                      <option [selected]="currentPageLength == 1000">
                        1000
                      </option>
                    </select>
                    &nbsp;
                    <span> entries</span>
                  </div>
                </div> -->
              </div>

              <div class="table">
                <table
                  class="table-responsive"
                  datatable
                  [dtOptions]="dtOptions"
                  width="100%"
                >
                  <thead class="">
                    <tr>
                      <!-- <th scope="col">S/N</th> -->
                      <th scope="col">Departing Country</th>
                      <th scope="col">Departure Date</th>
                      <th scope="col">Return Date</th>
                      <th scope="col">Arriving Country</th>
                      <th scope="col">Arriving State</th>
                      <th scope="col">Arrival Date</th>
                      <th scope="col">Transit Country</th>
                      <th scope="col">Airline</th>
                      <th scope="col">Test Status</th>
                      <th scope="col">Country Of Residence</th>
                      <th scope="col">Residential Address</th>
                      <th scope="col">Nationality</th>
                      <th scope="col">Email</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Occupation</th>
                    </tr>
                  </thead>
                  <tbody class="dashboard-bg-white">
                    <tr
                      *ngFor="
                        let trip of passengerSingleResponse.travel_info
                          | paginate: config;
                        index as i
                      "
                    >
                      <!-- <th scope="row">1</th> -->
                      <th>{{ trip.departure_country }}</th>
                      <th>{{ trip.departure_date | date: "medium" }}</th>
                      <th>{{ trip.return_date | date: "medium" }}</th>
                      <th>{{ trip.arrival_country }}</th>
                      <th>{{ trip.arrival_state }}</th>
                      <th>{{ trip.arrival_date }}</th>
                      <th>{{ trip.transit_country }}</th>
                      <th>{{ trip.airline }}</th>
                      <th>{{ trip.status }}</th>
                      <th>{{ trip.country_residence }}</th>
                      <th>{{ trip.address_residential }}</th>
                      <th>{{ trip.nationality }}</th>
                      <th>{{ trip.email }}</th>
                      <th>{{ trip.phone }}</th>
                      <th>{{ trip.occupation }}</th>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- <div class="table-footer">
                <div
                  id="page_info"
                  class="mt-3 record-show-text-bottom"
                  *ngIf="registeredPassengers"
                >
                  Showing
                  {{
                    (config.currentPage - 1) * config.itemsPerPage + 1
                  }}
                  - {{ config.currentPage * config.itemsPerPage }} of
                  {{ config.totalItems }} entries
                </div>

                <div
                  class="pagination paging-pull-right"
                  *ngIf="registeredPassengers"
                >
                  <pagination-controls
                    (pageChange)="pageChange($event)"
                    class="my-pagination mt-2 pagination-server"
                  >
                  </pagination-controls>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- End Travel History Table -->

      <!-- Start Appointment Details Table  -->
      <!-- <div class="row">
                    <hr />
                    <div class="col-md-12">         
                      <div class="">
                        <div class="table-responsive mt-5">
                          <div class="col-auto">
                            <div class="row">
                              <div class="col-md-12">
                                <h3>Appointment Details</h3>
                              </div>
                            </div>
          
                            <div class="row">                    
                            <div class="show-record mt-3 mbm-32">
                              <span>Show</span> &nbsp;
                              <select
                                class="
                                  custom-select custom-select-sm
                                  form-control form-control-sm
                                "
                                (change)="setItemsPerPage(page.value)"
                                #page
                              >
                                <option [selected]="currentPageLength == 10">
                                  10
                                </option>
                                <option [selected]="currentPageLength == 30">
                                  30
                                </option>
                                <option [selected]="currentPageLength == 50">
                                  50
                                </option>
                                <option [selected]="currentPageLength == 100">
                                  100
                                </option>
                                <option [selected]="currentPageLength == 500">
                                  500
                                </option>
                                <option [selected]="currentPageLength == 1000">
                                  1000
                                </option>
                              </select>
                              &nbsp;
                              <span> entries</span>
                            </div>
                          </div>
                          </div>
          
                          <table
                            class="
                              table
                              table-bordered
                              table-condensed
                              table-responsive-sm
                              table-responsive-md
                              table-responsive-lg
                              table-responsive-xl
                              nowrap
                            "
                            datatable
                            [dtOptions]="dtOptions"
                            width="100%"
                          >
                            <thead class="">
                              <tr>
                                <th scope="col">S/N</th>
                                <th scope="col">Booking Date</th>
                                <th scope="col">Expected City</th>
                                <th scope="col">Expected State</th>
                                <th scope="col">Prefer State</th>
                                <th scope="col">Created At</th>
                              </tr>
                            </thead>
                            <tbody class="dashboard-bg-white">
                              <tr>
                                <th scope="row">1</th>
                                <th>25 March 2021</th>
                                <th>28 March 2021</th>
                                <th>AquaAirline</th>
                                <th>Nigeria</th>
                                <th>Ghana</th>
                              </tr>
                            </tbody>
                          </table>
          
                          <div class="table-footer">
                          <div
                            id="page_info"
                            class="mt-3 record-show-text-bottom"
                            *ngIf="registeredPassengers"
                          >
                            Showing
                            {{
                              (config.currentPage - 1) * config.itemsPerPage + 1
                            }}
                            - {{ config.currentPage * config.itemsPerPage }} of
                            {{ config.totalItems }} entries
                          </div>
          
                          <div
                            class="pagination paging-pull-right"
                            *ngIf="registeredPassengers"
                          >
                            <pagination-controls
                              (pageChange)="pageChange($event)"
                              class="my-pagination mt-2 pagination-server"
                            >
                            </pagination-controls>
                          </div>
                        </div>
                        </div>
                      </div>            
                    </div>
                  </div> -->
      <!-- End Appointment Details Table -->

      <!-- Start Covid Test Details Table  -->
      <!-- <div class="row">
                      <hr />
                      <div class="col-md-12">         
                        <div class="">
                          <div class="table-responsive mt-5">
                            <div class="col-auto">
                              <div class="row">
                                <div class="col-md-12">
                                  <h3>Covid Test Details</h3>
                                </div>
                              </div>
            
                            </div>
            
                            <table
                              class="
                                table
                                table-bordered
                                table-condensed
                                table-responsive-sm
                                table-responsive-md
                                table-responsive-lg
                                table-responsive-xl
                                nowrap
                              "
                              datatable
                              [dtOptions]="dtOptions"
                              width="100%"
                            >
                              <thead class="">
                                <tr>
                                 
                                  <th scope="col">Col 1</th>
                                  <th scope="col">Col 2</th>
                                  <th scope="col">Col 3</th>
                                </tr>
                              </thead>
                              <tbody class="dashboard-bg-white">
                                <tr>
                                  <th>Val 1</th>
                                  <th>Val 2</th>
                                  <th>Val 3</th>
                                </tr>
                              </tbody>
                            </table>
        
                          </div>
                        </div>            
                      </div>
                    </div> -->
      <!-- End Covid Test Details Table -->
    </div>
  </div>
</ng-template>

<app-footer-dashboard></app-footer-dashboard>
